var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EA4545",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1933 13.8594H20.4733C15.9833 13.8594 12.3333 17.5094 12.3333 21.9994C12.3333 26.4894 15.9833 30.1394 20.4733 30.1394H24.1933C28.6833 30.1394 32.3333 26.4894 32.3333 21.9994C32.3333 17.5094 28.6833 13.8594 24.1933 13.8594ZM20.4733 26.4194C18.0333 26.4194 16.0533 24.4394 16.0533 21.9994C16.0533 19.5594 18.0333 17.5794 20.4733 17.5794C22.9133 17.5794 24.8933 19.5594 24.8933 21.9994C24.8933 24.4394 22.9133 26.4194 20.4733 26.4194Z",
    fill: "#EA4545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceInactive);
export default __webpack_public_path__ + "static/media/device-inactive.798b7a2c2bec383fd7a4728be99c4673.svg";
export { ForwardRef as ReactComponent };